import { z } from 'zod';
import { legalClientSchema } from '../../ILegalClient';
import { realEstatePurchaseContractInventoryOptionSchema } from './IRealEstatePurchaseContractInventoryOption';

export const realEstatePurchaseContractSchema = z.object({
  idRealEstatePurchaseContract: z.number().optional(),
  idRealEstate: z.number(),
  idLegalTransaction: z.number(),
  /** Anzeigetitel des Vorgangs – vom Backend befüllt */
  LegalTransactionTitle: z.string().optional(),
  Price: z.number().nullable(),
  PriceInventoryOption: z.number().nullable(),
  PaymentMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  OrderMeasurement_idPurchaseContractRelationType: z.number().nullable(),
  requiresClearance: z.boolean(),
  clearanceDate: z.string().nullable(),
  isRented: z.boolean(),
  TenantArray: z.array(legalClientSchema),
  InventoryOptionArray: z.array(
    realEstatePurchaseContractInventoryOptionSchema
  ),
});

export type IRealEstatePurchaseContract = z.infer<
  typeof realEstatePurchaseContractSchema
>;

export const initRealEstatePurchaseContract = (
  idRealEstate: number,
  idLegalTransaction: number
): IRealEstatePurchaseContract => ({
  idRealEstate,
  idLegalTransaction,
  Price: null,
  PriceInventoryOption: null,
  PaymentMeasurement_idPurchaseContractRelationType: null,
  OrderMeasurement_idPurchaseContractRelationType: null,
  requiresClearance: false,
  clearanceDate: null,
  isRented: false,
  TenantArray: [],
  InventoryOptionArray: [],
});
